import { useMutation, UseMutationOptions } from 'react-query';

import { userApi } from 'src/Services/API';

export const useUpdateLastAssetOnboardingInvitationDate = (
  options?: UseMutationOptions<void, unknown, void>
) => {
  return useMutation<void, unknown, void>(
    ['update-last-asset-onboarding-invitation-date'],
    async () => {
      const response = await userApi.userControllerUpdateLastAssetOnboardingInvitationDate();
      return response.data;
    },
    options
  );
};

export default useUpdateLastAssetOnboardingInvitationDate;
